export type RuntimeEnvironment = 'local' | 'dev' | 'staging' | 'prod';

export const getEnvironmentFromUrl = (url: string): RuntimeEnvironment => {
  if (url.includes('localhost')) {
    return 'local';
  }

  if (url.includes('.dev.')) {
    return 'dev';
  }

  if (url.includes('.staging.')) {
    return 'staging';
  }

  return 'prod';
};

export const getEnv = () => {
  const currURL = window.location.origin;

  if (
    currURL.indexOf('staging.') < 0 &&
    currURL.indexOf('dev.') < 0 &&
    currURL.indexOf('localhost') < 0
  ) {
    return 'prod';
  } else if (currURL.indexOf('staging.') > 0) {
    return 'staging';
  } else if (currURL.indexOf('dev.') > 0) {
    return 'dev';
  }
  // else
  return 'local';
};
